import { render } from "./ScannerView.vue?vue&type=template&id=8b4fbdfc"
import script from "./ScannerView.vue?vue&type=script&lang=js"
export * from "./ScannerView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__